var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-3"},[_c('div',{staticClass:"pb-3",domProps:{"innerHTML":_vm._s(_vm.mail)}}),(_vm.attachments.length != 0)?[_vm._m(0),_c('ul',_vm._l((_vm.attachments),function(link,index){return _c('li',{key:index},[_c('a',{attrs:{"href":link}},[_vm._v(_vm._s(link))])])}),0)]:_vm._e()],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_c('b',[_vm._v("Приложенные файлы:")])])
}]

export { render, staticRenderFns }